import request from '@/utils/request'

const baseUrl = '/erp/purchase-inbound'

export const pagePurchaseInbound = params => request({ url: baseUrl + '/page', method: 'get', params })
export const getPurchaseInbound = id => request({ url: baseUrl + '/detail', method: 'get', params: { id } })
export const savePurchaseInbound = data => request({ url: baseUrl + '/save', method: 'post', data })
export const auditPurchaseInbound = id => request({ url: baseUrl + '/audit', method: 'post', data: { id } })
export const reverseAuditPurchaseInbound = id => request({ url: baseUrl + '/reverse-audit', method: 'post', data: { id } })
export const deletePurchaseInbound = id => request({ url: baseUrl + '/delete', method: 'post', data: { id } })
export const listPurchaseInboundSku = keyword => request({
  url: baseUrl + '/sku-options', method: 'get', params: { keyword }
})
